import React from 'react';
import { IBox, Title, Content } from './inspinia';

export default class TemplateSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            obj: []
        }
    }

    getTemplates() {
        if (!this.props.templates) {
            return;
        }
        return this.props.templates.map(function (template, i) {
            return (
                <div value={template.id} onClick={this.props.onClick.bind(this, this.props.status, template.id)} className={i === 0 ? "carousel-item active" : "carousel-item"}>
                    <div>
                        <label>{template.nome}</label>
                    </div>
                   
                    <img className="d-inline" src="assets/images/Mask Group 2.svg" alt="First slide" />

                </div>
            );
        }.bind(this));
    }

    getQuantiaTemplates() {
        if (!this.props.templates) {
            return;
        }
        return this.props.templates.map(function (template, i) {
            return (
                <li data-target="#carouselExampleControls" data-slide-to={i} className={i === 0 ? "active" : ""}></li>
            );
        }.bind(this));
    }

    render() {
        return (
            <IBox className="mb-0 text-center">
                <Title>
                    <h3 className="mb-2">Templates</h3>
                </Title>

                <Content className="border-0 p-1" style={{ height: "188px" }}>
                    <div id="carouselExampleControls" className="carousel slide" data-ride="carousel" data-interval="false">

                        <div className="carousel-inner">
                            {this.getTemplates()}
                        </div>

                        <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                            <i className="text-secondary fa fa-chevron-left"></i>
                            <span className="sr-only">Previous</span>
                        </a>

                        <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                            <i className="text-secondary fa fa-chevron-right"></i>
                            <span className="sr-only">Next</span>
                        </a>

                        <ol className="carousel-indicators" style={{ bottom: "-40px" }}>
                            {this.getQuantiaTemplates()}
                        </ol>
                    </div>
                </Content>
            </IBox>
        )
    }
}
